import { render, staticRenderFns } from "./ApproverSettingsTemplate.vue?vue&type=template&id=6382a5b9"
import script from "./ApproverSettingsTemplate.vue?vue&type=script&lang=ts"
export * from "./ApproverSettingsTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6382a5b9')) {
      api.createRecord('6382a5b9', component.options)
    } else {
      api.reload('6382a5b9', component.options)
    }
    module.hot.accept("./ApproverSettingsTemplate.vue?vue&type=template&id=6382a5b9", function () {
      api.rerender('6382a5b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/ApproverSettingsTemplate/ApproverSettingsTemplate.vue"
export default component.exports